import { useState } from 'react';
import { AsyncBoundary, Notice } from '@kollez/design-system';
import { useSpecializations } from '@/lib/queries';

/**
 * /group/specializations (Page 76/N) — branches (CSE, ECE, Mech, Civil,
 * Marketing, HR, …) under each programme. Tenant-scoped.
 */

export function GroupSpecializationsPage() {
  const [status, setStatus] = useState('');
  const [q, setQ] = useState('');
  const list = useSpecializations({ status, q, sortBy: 'name', sortDir: 'asc', limit: 200 });
  const rows = list.data?.rows ?? [];

  return (
    <div className="stack">
      <div className="page-header">
        <div className="ph-text">
          <p className="eyebrow">Institutions · Catalog</p>
          <h1 className="h-page">Branches</h1>
          <p className="subhead">
            Every branch offered under a programme (CSE / ECE / Mech / Civil / Marketing /
            HR / …). Intake and NBA accreditation live one level down at the college level.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="filterbar">
          <input className="input" placeholder="Search branch name or code" value={q} onChange={(e) => setQ(e.target.value)} />
          <select className="select" value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value="">Any status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
            <option value="phasing_out">Phasing out</option>
          </select>
          <span className="fb-count">{list.data?.meta?.total ?? rows.length}</span>
        </div>

        <AsyncBoundary
          kind="table"
          inCard
          loading={list.isLoading}
          error={list.error}
          empty={!list.isLoading && rows.length === 0}
          emptyTitle="No branches in scope"
          emptyHint="Add a branch under one of your programmes to start populating this."
          onRetry={() => void list.refetch()}
        >
          <div className="tbl-wrap">
            <table className="tbl">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Code</th>
                  <th>Programme</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => {
                  const name = r.specializationName ?? r.name ?? r.shortName ?? '—';
                  const code = r.specializationCode ?? r.code ?? '—';
                  const prog =
                    typeof r.program === 'object' && r.program
                      ? r.program.name ?? r.program.programCode ?? '—'
                      : '—';
                  return (
                    <tr key={r._id}>
                      <td className="cell-title">{name}</td>
                      <td className="cell-sub">{code}</td>
                      <td className="cell-sub">{prog}</td>
                      <td><span className="badge">{r.status ?? '—'}</span></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </AsyncBoundary>
      </div>

      <Notice tone="info">
        <b>Per-college intake and NBA accreditation</b> live on the offering (Specialization.
        offeredAt[]), not on the branch definition itself.
      </Notice>
    </div>
  );
}
